import { memo } from 'react';
import { arrayOf, node, oneOfType } from 'prop-types';

export const NativeButton = memo(({ children, ...props }) => (
  <button type="button" {...props}>
    {children}
  </button>
));

NativeButton.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
};
